import { getTimezoneAbbreviation } from "@src/appV2/redesign/utils/getTimezoneAbbreviation";
import { addMinutes, isToday, parseISO, setMinutes } from "date-fns";
import { format } from "date-fns-tz";

export function formatToLocalTimezone(date: string, formatString: string): string {
  return format(parseISO(date), formatString);
}

export function formatToLocalTimezoneRounded(date: string, formatString: string): string {
  const parsedDate = parseISO(date);
  const minutes = parsedDate.getMinutes();
  const roundedMinutes = Math.ceil(minutes / 10) * 10;
  const roundedDate =
    roundedMinutes === 60
      ? addMinutes(setMinutes(parsedDate, 0), 60)
      : setMinutes(parsedDate, roundedMinutes);

  return format(roundedDate, formatString);
}

/**
 * Formats the date and time of the orientation in a human readable format
 *
 * @example
 * ```ts
 * formatOrientationDateTime("2025-05-08T07:59:52.517Z") // "May 8th at 1:29pm"
 * formatOrientationDateTime("2025-05-08T07:59:52.517Z", { roundTime: true }) // "May 8th at 1:30pm"
 * ```
 */
export function formatOrientationDateTime(date: string, options?: { roundTime?: boolean }): string {
  // Don't show the date if the orientation is today
  const formatString = isToday(parseISO(date)) ? "h:mm a" : "MMMM do 'at' h:mm a";
  return options?.roundTime
    ? formatToLocalTimezoneRounded(date, formatString)
    : formatToLocalTimezone(date, formatString);
}

/**
 * Checks if the worker's timezone is the same as the device's timezone
 */
export function isWorkerTimezoneMatchingDevice(workerTimezone: string): boolean {
  const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const deviceTimezoneAbbreviation = getTimezoneAbbreviation(deviceTimezone);
  const workerTimezoneAbbreviation = getTimezoneAbbreviation(workerTimezone);

  return deviceTimezoneAbbreviation === workerTimezoneAbbreviation;
}
